import React, { useEffect, useState } from 'react'
import { MdOutlineLightMode, MdOutlineDarkMode } from 'react-icons/md'

// The `.dark` class is applied by the inline script in public/index.html before
// first paint, so there is no flash. This just keeps it in sync afterwards.
const isDark = () =>
  typeof document !== 'undefined' && document.documentElement.classList.contains('dark')

export const ThemeToggle = ({ className = '' }) => {
  const [dark, setDark] = useState(isDark)

  useEffect(() => setDark(isDark()), [])

  const toggle = () => {
    const next = !dark
    setDark(next)
    document.documentElement.classList.toggle('dark', next)
    const meta = document.querySelector('meta[name="theme-color"]')
    if (meta) meta.setAttribute('content', next ? '#140e0d' : '#4d1414')
    try {
      localStorage.setItem('theme', next ? 'dark' : 'light')
    } catch (e) {
      /* storage blocked (private browsing) — theme just won't persist */
    }
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={dark ? 'Switch to light theme' : 'Switch to dark theme'}
      title={dark ? 'Light mode' : 'Dark mode'}
      className={` grid h-9 w-9 place-items-center rounded-full border border-ink/15 text-ink/60 transition-colors hover:border-mint-deep hover:text-mint-deep ${className}`}
    >
      {dark ? <MdOutlineLightMode className=" text-lg" /> : <MdOutlineDarkMode className=" text-lg" />}
    </button>
  )
}
